import { checkinApi } from '@/services/api/httpClient';

const paperlessActions = {
  async uploadFilesOnPaperless({ getters }, { file, requestConfigs }) {
    const admissionId = getters.getCurrentAdmissionState.data.id;

    const url = `/admission/${admissionId}/upload-medical-order`;
    try {
      const resp = await checkinApi().postForm(url, {
        file,
      });
      return resp.data;
    } catch (error) {
      console.error('Erro ao subir arquivo', error);
      return null;
    }
  },
};

export default paperlessActions;
